var AuthPlugin = {
  setToken: function(token) {
    //var expiration = Date.now()+ 20*60*1000; // 4 hours;
    localStorage.setItem("authToken", token);
    //localStorage.setItem('authTokenExpiration', expiration);
  },

  destroyToken: function() {
    localStorage.removeItem("authToken");
    localStorage.removeItem("authTokenExpiration");
    localStorage.removeItem("ebarimtInfo");
  },

  setMe: function(me) {
    localStorage.setItem("me", JSON.stringify(me));
  },
  getMe: function() {
    return JSON.parse(localStorage.getItem("me"));
  },
  setShowQR: function() {
    localStorage.setItem("showQR", JSON.stringify("false"));
  },
  setShowQRTrue: function() {
    localStorage.setItem("showQR", JSON.stringify("true"));
  },
  getShowQR: function() {
    return JSON.parse(localStorage.getItem("showQR"));
  },
  removeMe: function() {
    localStorage.removeItem("me");
  },

  getToken: function() {
    return localStorage.getItem("authToken");
  },
  loggedIn: function() {
    return !!this.getToken();
  },
  setPartnerCardHolderKey: function(partnerCardHolderKey){
    localStorage.setItem("partnerCardHolderKey", partnerCardHolderKey);
  },
  getPartnerCardHolderKey: function(){
    return localStorage.getItem("partnerCardHolderKey");
  },
  setPartnerPinCode: function(partnerPinCode){
    localStorage.setItem("partnerPinCode", partnerPinCode);
  },
  getPartnerPinCode: function(){
    return localStorage.getItem("partnerPinCode");
  },
  setCustomerInfo: function(customerInfo) {
    localStorage.setItem("customerInfo", JSON.stringify(customerInfo));
  },
  getCustomerInfo: function() {
    return JSON.parse(localStorage.getItem("customerInfo"));
  },
  removeCustomerInfo: function() {
    localStorage.removeItem("customerInfo");
  },
  setCardInfo: function(cardInfo) {
    localStorage.setItem("cardInfo", JSON.stringify(cardInfo));
  },
  getCardInfo: function() {
    return JSON.parse(localStorage.getItem("cardInfo"));
  },
  removeCardInfo: function() {
    localStorage.removeItem("cardInfo");
  },
  setEbarimtInfo: function(cardInfo) {
    localStorage.setItem("ebarimtInfo", JSON.stringify(cardInfo));
  },
  getEbarimtInfo: function() {
    return JSON.parse(localStorage.getItem("ebarimtInfo"));
  },
  removeEbarimtInfo: function() {
    localStorage.removeItem("ebarimtInfo");
  },
};

export default function(Vue) {
  Vue.auth = AuthPlugin;

  Object.defineProperties(Vue.prototype, {
    $auth: {
      get: function() {
        return Vue.auth;
      },
    },
  });
}
